import { FEATURES, PERMISSION_NOT_ALLOWED, ALLOWED } from '/src/features/_global/constants';

export const GLOBAL_PERMISSIONS = {
  [FEATURES.AI]: ({ capabilities, isSharing }) => {
    return isSharing
      ? {
          summarize: PERMISSION_NOT_ALLOWED,
        }
      : {
          summarize: capabilities?.ai.permissions.summarize,
        };
  },
  [FEATURES.EXPORT]: ({ capabilities, isSharing }) => {
    return isSharing
      ? {
          csv: ALLOWED, // sc-63754
          json: PERMISSION_NOT_ALLOWED,
        }
      : {
          csv: capabilities?.export.permissions.csv,
          json: capabilities?.export.permissions.json,
        };
  },
};
